import React from "react";

const Client = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill || "#9A5BFF"}
            d="M34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2s16 7.163 16 16Z"
        />
        <path
            fill="#fff"
            d="M10.14 28.48c0-2.118.828-4.149 2.302-5.646A7.798 7.798 0 0 1 18 20.495c2.084 0 4.084.841 5.558 2.339a8.049 8.049 0 0 1 2.302 5.646H10.14ZM18 19.497c-3.257 0-5.895-2.68-5.895-5.988 0-3.309 2.638-5.988 5.895-5.988 3.257 0 5.895 2.68 5.895 5.988 0 3.308-2.638 5.988-5.895 5.988Z"
        />
    </svg>
);

export default Client;
